import { I18nKey } from "@/libs/shared";
import styled from "@emotion/styled";
import { Chip } from "@mui/material";
import { Filters } from "../types";

export const FILTER_CHIP_I18N_KEYS = [
  { field: "assigned" as keyof Filters, key: "assessments.status.assigned_to_me" },
  { field: "isAnswered", key: "assessments.status.answered" },
  { field: "isNotAnswered", key: "assessments.status.not_answered" },
  { field: "inReview", key: "assessments.status.in_review" },
  { field: "unassigned", key: "assessments.status.unassigned" },
  { field: "reviewed", key: "assessments.status.reviewed" },
  { field: "declined", key: "assessments.status.declined" },
] as { field: keyof Filters; key: I18nKey }[];

export const FilterChip = styled(Chip)({
  borderRadius: "4px",
  border: "1px solid var(--Soft-Black-Gray-Scale-300, #E8E8E8)",
  background: "var(--Soft-Black-Gray-Scale-200, #F2F2F2)",
  height: "24px",
  padding: "2px 8px",
  gap: "4px",
  fontSize: "12px",
  ".MuiChip-label": {
    paddingLeft: 0,
  },
});
